_collow.components.editButton = class editButton extends _collow.components.Base {
  root;

  constructor(root) {
    super();  
    this.root = root;
    window.addEventListener("load", this.showButtonForAdmin);
    // this.showButtonForAdmin()
  }

  handleButtonClick = () => {
    let currentUrl = window.location.href;
    let url = new URL(currentUrl);
    let params = url.searchParams;

    // Toggle the 'language_edit' query parameter, Remove if it exists, Add if it doesn't exist
    if (params.has("language_edit")) {
      params.delete("language_edit");  
    } else {
      params.set("language_edit", "1");  
    }
    url.search = params.toString();
    window.location.href = url.toString();
  };

  showButtonForAdmin = () => {
    // Retrieve the user role from localStorage
    let progressJson = JSON.parse(window.localStorage.getItem("progressJson"));
    
    // If the user is an admin (role == 2), make the edit button visible and usable
    const languageDropdown = document.querySelector(".gt_switcher-popup");
    if (progressJson?.role != 2 || !languageDropdown) return;
    this.listen(this.root, 'click', this.handleButtonClick);
    this.root.removeAttribute("hidden");
  };
};
